export default "__VITE_ASSET__CwmAI4Ln__"